import { CALL_API } from '../middleware/api';

export const DATA_REQUEST = 'DATA_REQUEST';
export const DATA_SUCCESS = 'DATA_SUCCESS';
export const DATA_FAILURE = 'DATA_FAILURE';

function fetchData() {
  return {
    [CALL_API]: {
      types: [DATA_REQUEST, DATA_SUCCESS, DATA_FAILURE],
      endpoint: '/data.json',
    },
  };
}

export function loadData() {
  return (dispatch) => dispatch(fetchData());
}



// WEBPACK FOOTER //
// ./common/actions/index.js